import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import PaperList from '@/views/PaperList.vue'
import Editor from '@/views/Editor.vue'
import EditorTest from '@/views/EditorTest.vue'
import { getStorageSync } from '@/utils/uni-app'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/paperlist',
    name: 'PaperList',
    component: PaperList,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor',
    name: 'Editor',
    component: Editor,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor-test',
    name: 'EditorTest',
    component: EditorTest,
    meta: { requiresAuth: true }
  },
  {
    path: '/summary',
    name: 'Summary',
    component: () => import('@/views/Summary.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/painter',
    name: 'Painter',
    component: () => import('@/views/Painter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-coloring-list',
    name: 'AiColoringList',
    component: () => import('@/views/AiColoringList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/image-generator',
    name: 'ImageGenerator',
    component: () => import('@/views/ImageGenerator.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/extreme-color',
    name: 'ExtremeColor',
    component: () => import('@/views/ExtremeColor.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/views/Wallet.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getStorageSync('token')
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
